import classNames from 'classnames';
import Typography from '@/components/atoms/typography/typography';
import Youtube from '@/components/molecules/youtube/youtube';
import Column from '@/components/utilities/column/column';
import Container from '@/components/utilities/container/container';
import Row from '@/components/utilities/row/row';
import { getYoutubeId } from '@/libraries/getters/get-youtube-id';
import styles from './video-media-block.module.scss';

export interface VideoMediaBlockProps {
  /** The text to show as a caption */
  caption?: string | null;
  /** The class name to apply */
  className?: string;
  /** The video to show */
  video?: Content.Properties.YoutubeVideo | null;
}

const VideoMediaBlock = ({
  caption,
  className,
  video,
}: VideoMediaBlockProps) => {
  return (
    <div className={classNames(styles.component, className)}>
      <Container>
        {video && (
          <Row>
            <Column
              className={styles.column}
              offset={{ laptop: 1 }}
              width={{ laptop: 10 }}
            >
              <Youtube
                className={styles.video}
                controls
                thumbnail={video.thumbnailImage}
                videoId={getYoutubeId(video.url)}
              />

              {caption && (
                <Typography
                  className={styles.caption}
                  tag="p"
                  tagStyle="labelMedium"
                >
                  {caption}
                </Typography>
              )}
            </Column>
          </Row>
        )}
      </Container>
    </div>
  );
};

VideoMediaBlock.displayName = 'VideoMediaBlock';

export default VideoMediaBlock;
